export const BUNDLE = {
  featureName: 'dashboard-program-not-enrolled',
};
